import { CLEAR_PAGE } from '../base/types';
import { FETCH_NOTES, CREATE_NOTE, UPDATE_NOTE, DELETE_NOTE } from './actionsTypes';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const notesReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_NOTES}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_NOTES}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoading: false,
        isLoaded: true,
      };
    case `${FETCH_NOTES}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case `${CREATE_NOTE}_FULFILLED`:
      return {
        ...state,
        data: [payload, ...state.data],
      };
    case `${DELETE_NOTE}_FULFILLED`:
      return {
        ...state,
        data: state.data.filter((i) => Number(i.id) !== Number(payload?.id)),
      };
    case `${UPDATE_NOTE}_FULFILLED`:
      return {
        ...state,
        data: state.data.map((i) => {
          if (Number(i.id) === Number(payload.id)) {
            return payload;
          }
          return i;
        }),
      };

    case CLEAR_PAGE:
      return payload === 'consultation' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default notesReducer;
